module.exports = __webpack_public_path__ + "img/logo.90187c5f.png";